import script from "./HomeTurtles.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTurtles.vue?vue&type=script&setup=true&lang=js"

import "./HomeTurtles.vue?vue&type=style&index=0&id=3095f5b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3095f5b7"]])

export default __exports__